import { css } from "@emotion/react";
import { IconButton, styled } from "@mui/material";

export const OverlayMenuIconButton = styled(IconButton)(
    () => css`
        color: #232729;
        width: 24px;
        height: 24px;
        padding: 2px;
        &:hover {
            background-color: #d0d0d0;
        }
    `,
);
